import { Heading } from '@moonpig/launchpad-components'
import { styled } from '@moonpig/launchpad-utils'
import { system as s } from '@moonpig/launchpad-system'

export const StyledHeading = styled(Heading)`
  ${s({
    mt: 3,
    mb: 5,
    ml: { xs: 6, md: 10 },
    typography: { xs: 'typeMobileDisplay04', md: 'typeDesktopDisplay05' },
    color: 'colorTextHeadline',
  })}
`
